<label for="form-field" [style.display]=labelDisplay>{{ _title }}</label>
<ng-content select="input, textarea, select, cmx-select, datepicker-input, number-input, time-input"></ng-content>
<span class="cmx-error-message" *ngIf="error">
  <ng-content select="error-message"></ng-content>
</span>